<template>
    <a class="btn btn-default favourite "
       :class="{ disabled: disabled }"
       :title="linkTitle"
       @click="submitFavourite"
    >
        <i :class="iconClass" />
    </a>
</template>

<script>
import { addHeaderMessage } from 'src/lib/messages.js'

export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        initial: {
            type: String,
            required: true,
        },
        submitUrl: {
            type: String,
            required: true,
        },
    },
    data: function() {
        return {
            onIcon: 'fa fa-bookmark',
            favourited: false,
        }
    },
    computed: {
        linkTitle: function() {
            if (this.favourited) {
                return 'Remove from my favourites'
            } else {
                return 'Add to my favourites'
            }
        },
        iconClass: function() {
            if (this.favourited) {
                return this.onIcon
            } else {
                return this.onIcon + '-o'
            }
        }
    },
    created: function() {
        this.favourited = this.initial === 'True'
    },
    methods: {
        submitFavourite: function() {
            var component = this
            $.get(
                this.submitUrl,
                function(data) {
                    component.favourited = data.favourited
                    addHeaderMessage(data.message)
                }
            )
        }
    }
}
</script>
